import { OrderItemsTypes } from "../../../constants/OrderItemsTypes";
import PaymentMethods from "../../../constants/PaymentMethods";
import Basket from "../../../entities/manhattan/basket/Basket";
import { IApplicableBenefit, IBasketOrderItem, IBasketOrderItems, IOrderBasket, IOrderBasketCampaignType, IOrderBasketOreInfo } from "../../../entities/manhattan/order/types";
import { getAllBasketItems, getOrderItemsByName } from "../../../utilites/order";
import { removeDotFromPrice, formatPrice, formatAndDividePrice } from "../../../utilites/util";
import { IManhattanFactory } from "../types";
import { BasketOrderItemFactory } from "./BasketOrderItemFactory";
import { BasketOrderItemSubtotalMonthlyFactory } from "./BasketOrderItemSubtotalMonthlyFactory";
import { ItemsPriceFactory } from "./ItemsPriceFactory";

export const BasketFactory: IManhattanFactory = class BasketFactory {

  static create(basket: IBasketOrderItems[] | null): IOrderBasket | null {
    if (basket) {
      let cosmosParticipationPrice = 0;
      let msisdnPrice = 0;
      let simActivationPrice = 0;
      let totalPriceForCheckout = 0;
      let totalPriceForFirstBill = 0;
      let totalMonthlyPrice = 0;
      let installationPrice = 0;
      let deliveryPrice = 0;

      const basketItems = basket.map((basketItems: IBasketOrderItems) => {
        const basketOrderItems = basketItems.items.map((item: IBasketOrderItem) => {
          return BasketOrderItemFactory.create(item);
        });

        const basketItemsSubtotal = BasketOrderItemSubtotalMonthlyFactory.create(basketOrderItems);
        totalMonthlyPrice += Number(removeDotFromPrice(basketItemsSubtotal?.price));

        const itemsTotal = ItemsPriceFactory.create(basketOrderItems, basketItems.type);
        return {
          type: basketItems.type,
          items: basketOrderItems,
          subtotal: basketItemsSubtotal,
          ore: basketItems.ore,
          deviceItemsTotal: itemsTotal.deviceCartTotal,
          otherItemsTotal: itemsTotal.otherCartTotal,
          tariffPackageTotal: itemsTotal.tariffPackageCartTotal
        };
      });

      const orderItems = getAllBasketItems(basketItems);

      const participationItems = getOrderItemsByName(
        orderItems,
        OrderItemsTypes.COSMOS_PARTICIPATION
      );

      const msisdnItems = getOrderItemsByName(
        orderItems,
        OrderItemsTypes.MSISDN
      );

      const simActivationItems = getOrderItemsByName(
        orderItems,
        OrderItemsTypes.SIM_ACTIVATION
      );

      const installationItems = getOrderItemsByName(
        orderItems,
        OrderItemsTypes.INSTALLATION_COST
      );

      const deliveryItems = getOrderItemsByName(
        orderItems,
        OrderItemsTypes.DELIVERY_COST
      );


      participationItems.forEach(item => {
        if (item?.price?.amount) {
          cosmosParticipationPrice += item.price.amount;
        }
      });

      msisdnItems.forEach(item => {
        if (item?.price?.amount) {
          msisdnPrice += item.price.amount;
        }
      });

      simActivationItems.forEach(item => {
        if (item?.price?.amount) {
          simActivationPrice += item.price.amount;
        }
      });

      installationItems.forEach(item => {
        if (item?.price?.amount) {
          installationPrice += item.price.amount;
        }
      });

      deliveryItems.forEach(item => {
        if (item?.price?.amount) {
          deliveryPrice += item.price.amount;
        }
      });

      orderItems.forEach(item => {
        if (item?.price?.isPaidOnCheckout) {
          if (item.price.amount > 0) {
            totalPriceForCheckout +=  (item.price.amount - item.price.discount);
          }
        }
        if (item?.price?.paymentType === PaymentMethods.FIRST_BILL && item?.price?.amount) {
          totalPriceForFirstBill += item.price.amount - item.price.discount;
        }
      });


      const oreItemFound = basketItems.find(
        (item: IBasketOrderItems) => item.ore
      );

      const basketCampaignType = basket.find(
        (item: IBasketOrderItems) => item.campaignType
      );

      //@ts-ignore
      const applicableBenefits: IApplicableBenefit[] = basket[0].applicableBenefits ?? [];
      const ore: IOrderBasketOreInfo | null = oreItemFound?.ore ?? null;
      const campaignType: IOrderBasketCampaignType | null = basketCampaignType?.campaignType ?? null;
      const participationInTotal: string | number = formatAndDividePrice(cosmosParticipationPrice);
      const totalOnCheckout: string | number = formatAndDividePrice(totalPriceForCheckout);
      const activationOfNumber: string | number = formatAndDividePrice(simActivationPrice);
      const specialMsisdn: string | number = formatAndDividePrice(msisdnPrice);
      const totalInFirstBill: string | number = formatAndDividePrice(totalPriceForFirstBill);
      const totalMonthlyPayment: string | 0 = formatPrice(totalMonthlyPrice);
      const installationCost: string | 0 = formatAndDividePrice(installationPrice);
      const deliveryCost: string | 0 = formatAndDividePrice(deliveryPrice);

      return new Basket(
        basketItems,
        applicableBenefits,
        ore,
        campaignType,
        participationInTotal,
        totalOnCheckout,
        activationOfNumber,
        specialMsisdn,
        totalInFirstBill,
        totalMonthlyPayment,
        installationCost,
        deliveryCost
      );
    }

    return null;
  }

};
